import { Tabs } from '@studiometa/ui';
import { transition, nextFrame, addClass, removeClass } from '@studiometa/js-toolkit/utils';

/**
 *  Quick Access component
 */
export default class QuickAccess extends Tabs {
  /**
   * Component Configuration
   */
  static config = {
    name: 'QuickAccess',
    refs: [...Tabs.config.refs, 'indicator', 'progress', 'animated[]'],
    options: {
      styles: {
        type: Object,
        merge: true,
        default: () => ({
          btn: {
            open: 'text-gold',
            closed: 'text-black-700',
          },
          content: {
            open: 'opacity-100 visible pointer-event-auto delay-100',
            closed: 'absolute opacity-0 pointer-events-none invisible',
          },
        }),
      },
    },
  };

  /**
   * CurrentIndex
   * @type {number}
   */
  currentIndex = 0;

  /**
   * Store to save the sizes of each btn.
   * @type {Array<{ x: number, width: number }>}
   */
  sizes = [];

  /**
   * Mounted hook
   */
  mounted() {
    super.mounted();
    this.setSizes();
    nextFrame(() => {
      this.updateIndicator(0);
      this.revealElements(0);
    });
  }

  /**
   * Resized hook.
   */
  resized() {
    this.setSizes();
    nextFrame(() => this.updateIndicator(this.currentIndex));
  }

  /**
   * Switch tab on button click.
   * @this {TabsInterface}
   * @param  {Event}  event The click event object.
   * @param  {number} index The index of the clicked button.
   * @returns {void}
   */
  onBtnClick(event, index) {
    super.onBtnClick(event, index);
    this.updateIndicator(index);
    this.revealElements(index);
    this.currentIndex = index;
  }

  /**
   * Set sizes
   */
  setSizes() {
    const origin = this.$refs.indicator.getBoundingClientRect();

    this.$refs.btn.forEach((btn, index) => {
      const { width, x } = btn.getBoundingClientRect();
      this.sizes[index] = {
        x: x - origin.x,
        width,
      };
    });
  }

  /**
   * Update indicator position.
   * @param {number} index to use.
   */
  updateIndicator(index) {
    transition(
      this.$refs.progress,
      {
        to: {
          transform: `translateX(${this.sizes[index]?.x}px) scaleX(${this.sizes[index]?.width})`,
          width: '1px',
        },
      },
      'keep'
    );
  }

  /**
   * Reveal elements.
   * @param {number} index to use.
   */
  revealElements(index) {
    this.$refs.animated.forEach((el) => {
      const options = {
        remove: el.dataset.optionRemove || '',
        delay: el.dataset.optionDelay || 0,
      };

      if (Number.parseInt(el.dataset.index, 10) === index) {
        setTimeout(() => {
          removeClass(el, options.remove);
        }, options.delay);
      } else {
        addClass(el, options.remove);
      }
    });
  }
}
